import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getIrrigation(context) {
      let response = await Vue.axios.get(
        `${URL_API}architecture/getbytype?architecture_type_id=8`
      );
      let data = response["data"];
      context.commit("updateIrrigation", data);
      return data;
    }
  },
  mutations: {
    updateIrrigation(state, data) {
      state.irrigation = data;
    }
  },
  state: {
    irrigation: {}
  },
  getters: {
    allIrrigation(state) {
      return state.irrigation;
    }
  }
};
